export default __webpack_public_path__ + "static/media/nao_inviabilize_sticker.d8b84e8e.png";